import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  deletebankList,
  getBankList,
  updateBankTerms,
  setCurrentData,
} from "../../../redux/actions/dbactions/bankActions";
import { useDispatch, useSelector } from "react-redux";
import { BankCard } from "./BankCard";
import { Col, Row, Spinner } from "react-bootstrap";
import { EditModal } from "./EditModal";
import { DeleteModal } from "../Modals/DeleteModal";
import { AcceptTermsModal } from "../Modals/AcceptTermsModal";
import { getSession } from "../../../redux/actions/authActions";
import { Header } from "../../Header";
import FacilitiesIcon from "../../../../assets/FacilitiesIcon";
import { Button } from "../../Button";

const BankLayout = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [deletenew, setDeletenew] = useState(false);
  const [accept, setAccept] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedID, setSelectedID] = useState(null);
  const [selectedStripeID, setSelectedStripeID] = useState({});
  const { role_id, user_has_bank_acct_yn } = getSession();

  useEffect(() => {
    if (refresh) {
      dispatch(getBankList());
    }
  }, [dispatch, refresh]);
  const { banklist, isLoading } = useSelector((state) => state.bankReducer);
  const bankList = banklist.usr?.rec || [];
  const handleDelete = (svc_bank_bank_name, svc_bank_id) => {
    setDeletenew(true);
    setRefresh(false);
    setSelectedID(svc_bank_id);
    setSelectedTitle(svc_bank_bank_name);
  };
  const handleAccept = (
    svc_bank_conn_acct_id,
    svc_bank_bank_name,
    svc_bank_id
  ) => {
    setAccept(true);
    setRefresh(false);
    setSelectedID(svc_bank_id);
    setSelectedTitle(svc_bank_bank_name);
    setSelectedStripeID({ svc_bank_conn_acct_id: svc_bank_conn_acct_id });
  };
  const handleEditModal = (data) => {
    setShow(true);
    setRefresh(false);
    dispatch(setCurrentData(data));
  };
  const handleIdDelete = () => {
    if (selectedID) {
      dispatch(deletebankList(selectedID));
      setRefresh(true);
      setDeletenew(false);
    }
  };
  const handleIdAccept = () => {
    //if (selectedID) {
    dispatch(updateBankTerms(selectedStripeID, selectedID));
    setRefresh(true);
    setAccept(false);
    //}
  };
  var filteredBanks = [];
  if (bankList && bankList.length > 0) {
    filteredBanks = bankList.filter((item) =>
      item.user_profile_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  return (
    <div>
      <Header pageTitle="Bank Details" icon={<FacilitiesIcon />} />
      <div className="ser_title_b px-[16px] flex-row sm:flex-col sm:px-8 mt-4">
        <h5 className="title">Bank List</h5>
        {role_id === "5" || (user_has_bank_acct_yn === "Y" && role_id === 4) ? (
          ""
        ) : (
          <Link to={`/dashboard/new-bank`}>
            <Button>+ &nbsp; Add new bank</Button>
          </Link>
        )}
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:px-4 m-0">
        {filteredBanks.length > 0 ? (
          filteredBanks.map((item, index) => (
            <Col className="mb-6" lg={4} sm={6} key={index}>
              <BankCard
                data={item}
                handleDelete={() =>
                  handleDelete(item.svc_bank_bank_name, item.svc_bank_id)
                }
                roleID={role_id}
                handleEditModal={handleEditModal}
                handleAccept={() =>
                  handleAccept(
                    item.svc_bank_conn_acct_id,
                    item.svc_bank_bank_name,
                    item.svc_bank_id
                  )
                }
              />
            </Col>
          ))
        ) : (
          <p className="text-center">No Bank Found</p>
        )}
      </Row>
      <EditModal
        show={show}
        onHide={() => setShow(false)}
        setRefresh={() => setRefresh(true)}
      />
      <DeleteModal
        show={deletenew}
        handleClose={() => setDeletenew(false)}
        selectedTitle={selectedTitle}
        handleDelete={handleIdDelete}
      />

      <AcceptTermsModal
        show={accept}
        handleClose={() => setAccept(false)}
        selectedTitle={selectedTitle}
        handleAccept={handleIdAccept}
      />
    </div>
  );
};
export default withRouter(BankLayout);
